var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm.$t('text.cusMasterLayout.noAccess'))+"\n    "),_c('button',{on:{"click":_vm.goToDashboard}},[_vm._v(_vm._s(_vm.$t('text.cusMasterLayout.dashboard')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }